/**
 * The app's word for a company / house, from the Owner role's name (owner's decision,
 * 10 Oct 2026): "Portfolio Owner" → "portfolio" / "portfolios". The server works it out
 * (backend app/core/terms.py) and sends it with /me; the role names are the same in every
 * company and only the Super Admin renames them.
 */
import type { Me } from '../api/types.ts';

export interface Words {
  /** Mid-sentence: "Pick another portfolio". */
  place: string;
  places: string;
  /** Start of a sentence or a title: "Portfolios". */
  Place: string;
  Places: string;
  /** The Owner role's name, e.g. "Portfolio Owner". */
  owner: string;
}

export const capitalise = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

export function wordsOf(me: Pick<Me, 'placeWord' | 'placesWord' | 'ownerRoleName'> | null | undefined): Words {
  const place = me?.placeWord || 'portfolio';
  const places = me?.placesWord || 'portfolios';
  return {
    place,
    places,
    Place: capitalise(place),
    Places: capitalise(places),
    owner: me?.ownerRoleName || `${capitalise(place)} Owner`,
  };
}
